import { render, staticRenderFns } from "./Traitement.vue?vue&type=template&id=55a9fd1c&"
import script from "./Traitement.vue?vue&type=script&lang=js&"
export * from "./Traitement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a9fd1c')) {
      api.createRecord('55a9fd1c', component.options)
    } else {
      api.reload('55a9fd1c', component.options)
    }
    module.hot.accept("./Traitement.vue?vue&type=template&id=55a9fd1c&", function () {
      api.rerender('55a9fd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/SCT/Traitement.vue"
export default component.exports